import GameStepBase, {createGameFlowCancelResponse} from '../game_step_base';
import {GNWP_SOURCES} from '../../../../components/external_links/external_links_consts';
import {PENDING_ACTIONS} from '../../../pending_action/pending_action_consts';

export default class ReadRealGameConfigurationGameStep extends GameStepBase {
    static CLASS = 'ReadRealGameConfigurationGameStep';

    run(gameOptions) {
        return new Promise((resolve, reject) => {
            this.serviceFactory.gameService()
                               .readRealGameConfiguration(gameOptions)
                               .then(gameConfiguration => {
                                   if(gameConfiguration.userHasPendingActions) {
                                       this.serviceFactory.pendingActionService().addPendingAction({
                                           name: PENDING_ACTIONS.GAME,
                                           persistent: false,
                                           options: Object.assign({}, gameOptions, {isReal: true, forceLogin: true})
                                       });
                                       this._showPendingPlayApplication(gameConfiguration.token);
                                       reject(createGameFlowCancelResponse('User has pending play action'));
                                   } else if(gameConfiguration.nightLimitExpirationDate) {
                                       this._showNightLimitMessage(new Date(gameConfiguration.nightLimitExpirationDate));
                                       reject(createGameFlowCancelResponse('User has active Night Limit'));
                                   } else {
                                       resolve(Object.assign(gameOptions, gameConfiguration));
                                   }
                               }).catch(err => reject(err));
        });
    }

    _showPendingPlayApplication(token) {
        this.serviceFactory.openLinkService().openLink({
            source: GNWP_SOURCES.PENDING_PLAY,
            options: {
                token: token
            }
        });
    }

    _showNightLimitMessage(nightLimitExpirationDate) {
        this.serviceFactory.regulationService().getRegulation().showNightLimitMessage(nightLimitExpirationDate);
    }
}